import { Icon } from '@components/primitives';

import colors from '@theme/colors';
import React from 'react';

const ArrowDown: React.FC = () => <Icon name="down" family="antdesign" color={colors.neutral.charcoal} />;

export default ArrowDown;
